export default __webpack_public_path__ + "static/media/sticker-gl.1b307bee.png";